










import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseInputRadio',

  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'update',
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
})
